import { isProduction } from 'shared/constants/AppTypeConstants';
import { useIntercomTour } from 'shared/hooks/useIntercomTour';
import { useFlag } from 'shared/settings/FeatureToggles';

const EDI_VEHICLES_INTERCOM_TOUR_ID = isProduction ? '668557' : '';
const EDI_VEHICLES_INTERCOM_TOUR_SEEN_STATE =
  'edi_vehicles_intercom_tour_seen_state';

export function useEdiVehiclesIntercomTour() {
  const isEdiVehiclesEnabled = useFlag('ctms_edi_vehicles');

  useIntercomTour({
    tourId: EDI_VEHICLES_INTERCOM_TOUR_ID,
    isEnabled: isEdiVehiclesEnabled,
    seenStateKey: EDI_VEHICLES_INTERCOM_TOUR_SEEN_STATE,
  });
}
